import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  scan: {
    width: 100,
    height: 100,
    d: `M21.49,53.19H15.15V46.85h6.34ZM40.6,15.08V40.52H27.82v6.33H21.49V40.52H15.15V15.08Zm-6.33,6.33H21.49V34.19H34.27Zm-.12,
    25.44H27.82v6.34h6.33ZM69.08,78.51H62.74V84.9h6.34Zm15.82.06H78.57V84.9H84.9ZM72.24,46.85H65.91v6.34h6.33Zm12.66,
    0H78.57v6.34H84.9Zm-6.33,6.34H72.24v6.33h6.33Zm6.33,6.33H78.57v6.33H84.9ZM56.2,
    21.59H53.1V15H46.77V27.78h-3.1v6.33h3.1v3H53.1V27.92h3.1Zm16,
    44.26V59.52H65.91v6.33h-16V84.9H56.2V72.18H69.08v6.33h6.33V72.18h3.16V65.85Zm3.1-41.21H69V31h6.33Zm-44.3,
    0H24.71V31H31ZM84.9,15.08V40.52H78.57v6.33H72.24V40.52H65.91v6.33H53.1v6.34h6.36v6.33H40.54V85H15.1V59.52H34.21V53.19H46.77V46.85H40.5V40.52h19V15.08ZM34.21,
    65.85H21.43V78.63H34.21ZM78.57,21.41H65.79V34.19H78.57ZM31,69.07H24.65v6.34H31Z`,
  },
});
